import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Text, {
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_KIND,
} from '@/bit/components/components.text';
import { sendTaggingInfo } from '@/utils/common';
import { maskSeparation as applyMaskSeparation } from '@/utils/mask';
import { calculateNewCaret } from './utils';
import styles from './styles';

export const COMPONENT_NAME = 'input-form';
export const COMPONENT_THEME = {
  BOX: 'input-form--default',
  NO_BOX: 'input-form--no-box',
};
function Input({
  className,
  id,
  name,
  label,
  theme,
  mask,
  info,
  error,
  value,
  onFocus,
  onChange,
  onBlur,
  autocomplete,
  showError,
}) {
  const [inputValue, setInputValue] = useState('');
  const [key, setKey] = useState('');
  const taggingInfo = {
    componentVariation: 'all',
    componentProduct: '',
    componentName: 'input',
    componentContent: label,
  };

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleOnFocus = () => {
    sendTaggingInfo(taggingInfo, 'focus');
    onFocus();
  };

  const inputOnKeyDown = (e) => {
    setKey(e.key);
  };
  const handleOnChange = (event) => {
    const currentValue = event.target.value;
    let maskedValue = currentValue;
    if (mask) {
      const { target } = event;
      let newCaretPosition = target.selectionStart;
      const { maxLength, separationLength, separator } = mask;
      maskedValue = applyMaskSeparation(
        currentValue,
        maxLength,
        separationLength,
        separator
      );
      newCaretPosition = calculateNewCaret(
        key,
        newCaretPosition,
        separationLength
      );
      target.value = maskedValue;
      target.setSelectionRange(newCaretPosition, newCaretPosition);
    }
    setInputValue(maskedValue);
    onChange(event);
  };

  const handleOnBlur = (event) => {
    onBlur(event);
  };
  const labelClassName = error
    ? 'input__label input__label--error'
    : 'input__label';
  return (
    <div className={`input ${className}`} data-cy={id}>
      <div className={theme}>
        <input
          className="input__field"
          id={id}
          data-cy={`${id}__input`}
          name={name}
          value={inputValue}
          label={label}
          type="text"
          placeholder=" "
          onChange={handleOnChange}
          onBlur={handleOnBlur}
          onKeyDown={inputOnKeyDown}
          onFocus={handleOnFocus}
          autoComplete={autocomplete}
        />
        <label htmlFor={id} className={labelClassName} data-cy={`${id}__label`}>
          {label}
        </label>
      </div>
      {showError && error && (
        <Text
          className="input__error"
          text={error}
          color={TEXT_COLOR.RED}
          kind={TEXT_KIND.SPAN}
          size={TEXT_SIZE.CAPTION3}
          cyData={`${id}__error`}
        />
      )}
      {info && !error && (
        <Text
          className="input__error"
          text={info}
          color={TEXT_COLOR.GREY5}
          kind={TEXT_KIND.SPAN}
          size={TEXT_SIZE.CAPTION3}
          cyData={`${id}__info`}
        />
      )}
      <style jsx>{styles}</style>
    </div>
  );
}
Input.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  theme: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  onFocus: PropTypes.func,
  mask: PropTypes.object,
  error: PropTypes.string,
  info: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  autocomplete: PropTypes.string,
  value: PropTypes.string,
  showError: PropTypes.bool,
};

Input.defaultProps = {
  className: '',
  label: 'input',
  theme: COMPONENT_THEME.BOX,
  error: '',
  info: '',
  mask: null,
  onChange: () => {},
  onBlur: () => {},
  onFocus: () => {},
  autocomplete: 'on',
  value: '',
  showError: true,
};
export default Input;
